import {EventEmitter, Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {TeamMembership} from '../../../types/team-management.type';

@Injectable({
  providedIn: 'root',
})
export class TeamSelectorService {
  readonly teamChanged$: EventEmitter<void> = new EventEmitter();
  readonly changeTeam$ = new Subject<TeamMembership>();

  teamChanged() {
    this.teamChanged$.emit();
  }

  changeTeam(teamMembership: TeamMembership) {
    this.changeTeam$.next(teamMembership);
  }
}
